import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment.development';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class CatalogsService {
  private readonly http = inject(HttpClient);
  private readonly localStorage = inject(LocalStorageService);
  private readonly url = `${environment.apiUrl}/administrative/catalogs/`;

  getStatuses(module: string = ''): any {
    return this.get(`${this.url}statuses/?module=${module}`);
  }

  getEventTypes(): any {
    return this.get(`${this.url}event-types/?page_size=1000`);
  }

  getServiceTypes(): any {
    return this.get(`${this.url}service-types/?page_size=1000`);
  }

  private get(url: string): any {
    const token = this.localStorage.get(STORAGE_ENUM.TOKEN);
    return this.http.get<any>(url, { headers: { Authorization: token ? `Bearer ${token}` : '' } });
  }
}
